import React from 'react';

/*

About - DAG Explorer
Thank you for visiting the DAG Explorer

DAG Explorer was built by community members @rex and @doc_holliday97

Something is not working. What to do?
Don't worry, all funds are SAFU.

Please create an issue on GitHub github.com/StardustCollective/dag-explorer/issues with a thorough explanation of the problem.

 */

export default () => <h1>About</h1>;
